export default "__VITE_ASSET__EsPdCOcP__"